export default {
  percent: num => `${(Math.round((num + 0.00001) * 100) / 100) * 100}%`,
};
